import _styled from"@emotion/styled";import{FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import{css}from"@emotion/react";import MainContainer from"../../mainContainer";export const AppLayout=_styled.div`
  ${props=>props.isWebFlowPage?`background: ${props.theme.colors.webFlowBackgroundColor};`:""}
  width: 100vw;
  height: ${props=>props.height}px;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-direction: column;
  overflow: hidden;
`;export const HeaderMenuItem=_styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  border-radius: 8px;
  cursor: ${props=>props.disabled?"not-allowed":"pointer"};
  ${mediaQuery({padding:["8px","8px 16px"]})}
`;export const ContentLayout=_styled.div`
  overflow: hidden;
  display: flex;
  width: 100%;
  flex: 1;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: nowrap;
`;export const MainContent=_styled.div`
  overflow: hidden;
  flex: 1;
  display: flex;
  row-gap: 8px;
  flex-direction: column;

  ${props=>props.isWebFlowPage?`background: ${props.theme.colors.webFlowBackgroundColor} !important;`:""}
`;export const mainContentClampStyles=css`
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
`;export const MainContentChildContainer=_styled.div`
  width: 100%;
  min-height: calc(var(--full-vh, 100vh) - 144px);
  display: flex;
  flex-direction: column;
  ${mainContentClampStyles}
`;export const MainNavContainer=_styled(MainContainer)`
  ${mediaQuery({marginRight:[0],padding:["4px 8px 4px 4px"]})}
  ${{"borderBottomWidth":"1px","--tw-border-opacity":"1","borderColor":"rgb(242 242 244 / var(--tw-border-opacity))","--tw-bg-opacity":"1","backgroundColor":"rgb(255 255 255 / var(--tw-bg-opacity))"}}
`;export const MainChildrenContainer=_styled.div`
  flex: 1;
  overflow: auto;
`;export const TopRightMenuContainer=_styled(FlexLayout)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: right;
  & > * {
    ${mediaQuery({marginRight:["16px","16px","16px","24px"]})}
  }
  & > *:last-child {
    margin-right: 8px;
  }
`;